import React from 'react';
import {Params} from './../params.jsx'
import SecondHead from './../components/SecondHead'
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import {description_room1, description_room2, description_room3, description_complex} from './../description'
import {images_1, images_2, images_3, images} from './../assets/rooms_img.jsx'
import { Link } from "react-router-dom";

function Rooms(props){


	return(
		<>
        <SecondHead lang = {props.lang} link = {props.link}/>

        <div className="container mymarge">
                <div className="row bg2">
                    <div className="col fs-2 mt-2 pt-3 pb-3 bg3 text-center">
                        <div className="rooms_head">
                            <p>{Params(props.lang).room} 1</p>
                         </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8 d-flex bg2 justify-content-center align-items-center">
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                
                            <div className="owl-carousel owl-theme">
                            <ImageGallery items = {images_1} autoPlay = {true}/>
                            </div>
                        </div>
                   </div>
                

                    <div className="col-md-4 bg3 d-flex flex-column justify-content-center">
                       <div className="fs-5 my-first-letter bg1 mx-3 mb-4 desc-room px-3 pt-3 pb-3">
                            {description_room1(props.lang)}
                            <div className="inter_description">
                               <p>
                                  {Params(props.lang).price}
                                  {props.Info[0].price} 
                                  {props.Info[0].currency}/{Params(props.lang).night}

                               </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-3 bg3">
                    <div className=" col-md-4 offset-md-4 text-center pt-3 pb-3">
                        <Link to="/room_1" className="btn btn-outline-success btn-lg mx-auto d-grid gap-2 col-9 bg5" role="button">
                          {Params(props.lang).choice_date}
                        </Link>
                    </div>
                </div>
            </div>

    <div className="container mymarge mt-3">
        <div className="row bg2">
            <div className="col fs-2 mt-2 pt-3 pb-3 bg3 text-center">
                <div className="rooms_head">
                    <p>{Params(props.lang).room} 2</p>
                
                 </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-8 d-flex bg2 justify-content-center align-items-center">
                <div className="w-100 h-100 d-flex justify-content-center align-items-center">

                    <div className="owl-carousel owl-theme">
                            <ImageGallery items = {images_2} autoPlay = {true}/>

                   
                    </div>
                </div>
                    

            </div>
                
            <div className="col-md-4 bg3 d-flex flex-column justify-content-center">
                   <div className="fs-5 my-first-letter bg1 mx-3 mb-4 desc-room px-3 pt-3 pb-3">
                        {description_room2(props.lang)}
                        <div className="inter_description">
                           <p>
                              
                              {Params(props.lang).price}
                              {props.Info[1].price}
                              {props.Info[1].currency}/{Params(props.lang).night}

                           </p>
                        </div>
                    </div>
                </div>
            </div>

        <div className="row mb-3 bg3">
            <div className="col-md-4 offset-md-4 text-center pt-3 pb-3">

                <Link to="/room_2" className="btn btn-outline-success btn-lg mx-auto d-grid gap-2 col-9 bg5" role="button">
                  {Params(props.lang).choice_date}
                </Link>

            </div>
        </div>
    </div>

    <div className="container mymarge ">
        <div className="row bg2">
            <div className="col fs-2 mt-2 pt-3 pb-3 bg3 text-center">
                <div className="rooms_head">
                    <p>{Params(props.lang).room} 3</p>
                
                 </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-8 d-flex bg2 justify-content-center align-items-center">
                <div className="w-75 h-75 d-flex justify-content-center align-items-center">

                    <div className="owl-carousel owl-theme">
                            <ImageGallery items = {images_3} autoPlay = {true}/>

                   
                    </div>
                    
                </div>

            </div>
                
        	<div className="col-md-4 bg3 d-flex flex-column justify-content-center">
               <div className="fs-5 my-first-letter bg1 mx-3 mb-4 desc-room px-3 pt-3 pb-3">
                    {description_room3(props.lang)}
                    <div className="inter_description">
                       <p>
                              {Params(props.lang).price}
                              {props.Info[2].price}
                              {props.Info[2].currency}/{Params(props.lang).night}
                          

                       </p>
                    </div>
                </div>
            </div>
    	</div>

        <div className="row mb-3 bg3">
            <div className="col-md-4 offset-md-4 text-center pt-3 pb-3">
                 <Link to="/room_3" className="btn btn-outline-success btn-lg mx-auto d-grid gap-2 col-9 bg5" role="button">
                   {Params(props.lang).choice_date}
                 </Link>
            </div>
        </div>
    </div>

    <div className="container mymarge ">
        <div className="row bg2">
            <div className="col fs-2 mt-2 pt-3 pb-3 bg3 text-center">
                <div className="rooms_head">
                     <p>{Params(props.lang).complex}</p>
                
                 </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-8 d-flex bg2 justify-content-center align-items-center">
                <div className="w-100 h-100 d-flex justify-content-center align-items-center">

                    <div className="owl-carousel owl-theme">
                            <ImageGallery items = {images} autoPlay = {true}/>

                   
                    </div>
                </div>
                    

            </div>

            <div className="col-md-4 bg3 d-flex flex-column justify-content-center">
               <div className="fs-5 my-first-letter bg1 mx-3 mb-4 desc-room px-3 pt-3 pb-3">
                    <div className="inter_description">
                       {description_complex(props.lang)}
                    </div>
                </div>
            </div>
                
            
        </div>

        <div className="row bg3">
            <div className="col-md-6 offset-md-3 text-center pt-3 pb-3">
                <div className="row">
                    <div className="col text-center fs-4 ">    
                        <p>{Params(props.lang).call}&nbsp;<a href= {Params().userPhone} className="text-primary">{Params().userPhone}</a></p>
                    </div>
                </div>
                    <div className="col text-center fs-4">   
                        <p>{Params(props.lang).write}&nbsp;<a href="mailto:mevnik@gmail.com" className="text-primary">{Params().userEmail}</a></p>  
                    </div>
            </div>
        </div>
    </div>

    </>
  
		)
}
export default Rooms;